import { BillOfMaterialDetailPage } from '@/features/bill-of-material/pages/BillOfMaterialDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bill-of-material/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bill_of_material.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BillOfMaterialDetailPage,
})
